<div class="ili-panel draw_tool_panel">
  <div class="input-group input-group-sm draw_tool_content">
    <span class="input-group-addon"><input checked="true" disabled="true" class="drawtool" type="checkbox">
    </span><input type="text" placeholder="Draw Image" [(ngModel)]="block.data.question" class="form-control">
  </div>
</div>
